import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity, View, Text , Image} from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';
import FreeText from './FreeText';

const styles = StyleSheet.create({
  container: {
    paddingTop: 15,
  },
  button: {
    width: 42,
    height: 42,
    borderRadius: 10,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 4,
  },
  row: {
    alignSelf: 'center',
  },
  firstRowLabel: {
    marginLeft: 4,
    color: '#FF4C4D',
    textAlign: 'left',
    fontFamily:FONT_STYLE.MEDIUM,
    fontSize:14
  },
  secondRowLabel: {
    marginRight: 4,
    color: '#0DC98B',
    textAlign: 'right',
    fontFamily:FONT_STYLE.MEDIUM,
    fontSize:14
  },
  itemContainer: {
    flexDirection: 'row',
    marginVertical: 4,
  },
  npsNumber:{
    fontSize:16,
    fontFamily:FONT_STYLE.BOLD
  }
});

const FeelItem = ({
  point,
  selectedPoint,
}: {
  point: number;
  selectedPoint: number;
}) => {
  const selected = selectedPoint === point;
  return (
    <View
      style={[
        styles.button,
        {
            width: 60,
            height: 78,
            borderRadius: 8,
            borderWidth: 2
        },
      ,{
        borderColor: selected?'#F65D79':'#FFFFFF'
      }]}>
        <Image style={
            {
                width:60,
                height:78
            }
        } source={require(`../../assets/feel_${point}.png`)}></Image>
    </View>
  );
};

const Feel = ({onSelect , defaultAnswer=null, isCustom=false}) => {
const [selectedPoint, setSelect] =  useState(-1)
const [isOtherChoice, setVisibleTextInput] = useState(false)
const [otherReason, setOtherReason]= useState('')

  const handlePress = (point: number) => {
    setVisibleTextInput(isCustom)
    if(onSelect){
        onSelect(point,otherReason);
    }
    setSelect(point);
  };

  const onChangeText=(text)=>{
    setOtherReason(text);
    if(onSelect){
      onSelect(selectedPoint,text);
  }
  }


  useEffect(()=>{
    if(defaultAnswer && defaultAnswer.values){
      let valueNum = Number.parseInt(defaultAnswer.values[0]);
      setSelect(valueNum);
    }
  },[])

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <View style={styles.itemContainer}>
          {Array.from({ length: 5 }, (_, i) => i ).map(item => {
            return (
              <TouchableOpacity
                key={item}
                onPress={() => handlePress(item +1)}>
                <FeelItem
                  point={item +1}
                  selectedPoint={selectedPoint}
                />
              </TouchableOpacity>
            );
          })}
        </View>
      </View>
      {
         isOtherChoice?(
          <View>
          <Text style={{fontFamily:FONT_STYLE.BOLD, fontSize:14, marginTop:15}}>Bạn có thể cho biết lý do không ?</Text>
          <FreeText handleText={onChangeText}/>
          </View>
        ): null
      }
    </View>
  );
};

export default Feel;
